const dev = '_DEV';
const production = '';

export const env = production;
export const emailEnv = '';
export const url = env === dev ? 'https://app-test.strivere.com/' : 'https://app.strivere.com/';

